var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "53px",
    height: "36px",
    viewBox: "0 0 53 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    transform: "translate(-945.000000, -20.000000)",
    fill: "#324755"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(945.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.7692308,29.5384615 C51.5535353,29.5384615 53,30.9849262 53,32.7692308 C53,34.5535353 51.5535353,36 49.7692308,36 L3.23076923,36 C1.44646465,36 2.18514289e-16,34.5535353 0,32.7692308 C-2.18514289e-16,30.9849262 1.44646465,29.5384615 3.23076923,29.5384615 L49.7692308,29.5384615 Z M49.7692308,14.7692308 C51.5535353,14.7692308 53,16.2156954 53,18 C53,19.7843046 51.5535353,21.2307692 49.7692308,21.2307692 L3.23076923,21.2307692 C1.44646465,21.2307692 2.18514289e-16,19.7843046 0,18 C-2.18514289e-16,16.2156954 1.44646465,14.7692308 3.23076923,14.7692308 L49.7692308,14.7692308 Z M49.7692308,0 C51.5535353,8.04898639e-15 53,1.44646465 53,3.23076923 C53,5.01507381 51.5535353,6.46153846 49.7692308,6.46153846 L3.23076923,6.46153846 C1.44646465,6.46153846 2.18514289e-16,5.01507381 0,3.23076923 C-2.18514289e-16,1.44646465 1.44646465,3.27771433e-16 3.23076923,0 L49.7692308,0 Z",
    id: "Combined-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.fde1922440bcac2ef1853f092d4e5234.svg";
export { ForwardRef as ReactComponent };